import React from "react";
import styled from "styled-components";
import { useProfile } from "../../contexts/ProfileContext.tsx";

const TextP = styled.p`
  color: ${(props) => props.cor};
  text-align: center;
`;

function Text(props) {
  const { coresEmpresa } = useProfile();
  return <TextP cor={coresEmpresa.textosInputs}>{props.texto}</TextP>;
}

export default Text;